import React from "react";
import SendNotification from "./SendNotification";
import ExportSheet from "./ExportSheet";

const HeaderButtons = ({ userRole = "contractor", selectedIds }) => {
  return (
    <div className="flex items-center justify-between gap-2">
      <SendNotification userRole={userRole} selectedIds={selectedIds} />
      <ExportSheet userRole={userRole} />
    </div>
  );
};

export default HeaderButtons;
